/* eslint-disable no-undef */
export const SUCCESS_MESSAGE = data.form.success_message
export const ERROR_MESSAGE = data.form.error_message
export const ERROR_CORP_MAIL = data.form.error_corp_mail
export const ERROR_MAIL = data.form.error_mail
export const ERROR_FIELD = data.form.error_field
export const PHONE_SHORT = data.form.phone_short
export const PHONE_LONG = data.form.phone_long
export const ERROR_NUMBERS_ONLY = data.form.error_numbers_only
export const ACCEPTANCE_FALSE = data.form.acceptance_false
export const CAPTCHA_ERROR = data.form.captcha_false
export const CAPTCHA_FALSE_NUMBER = data.form.captcha_false_number
export const ERROR_FILE = data.form.error_file
export const ERROR_CORP_EMAIL = data.form.error_corp_email
export const ERROR_BASE_EMAIL = data.form.error_base_email
export const ERROR_PHONE = data.form.error_phone
export const MESSAGE_NAME = data.form.message_name
export const MESSAGE_COMPANY = data.form.message_company
export const MESSAGE_WORK = data.form.message_work
export const MESSAGE_PHONE = data.form.message_phone
export const MESSAGE_MAIL = data.form.message_mail
